import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import InsuranceLanguageBlock from '../../RequirementBlocks/InsuranceLanguageBlock';

import RequirementBlock from './RequirementBlock';

const RequiredLanguageBlock = ({ languageRequirements }) => (
  <RequirementBlock title="Required Language">
    {languageRequirements.length < 1
      ? <Text fontStyle="italics">None</Text>
      : languageRequirements.map(({ insuranceLanguage }) => (
        <InsuranceLanguageBlock
          description={insuranceLanguage.language}
          displayName={insuranceLanguage.displayName}
          isRequired={insuranceLanguage.required}
        />
      ))}
  </RequirementBlock>
);

RequiredLanguageBlock.propTypes = {
  languageRequirements: PropTypes.arrayOf(PropTypes.shape({
    language: PropTypes.string,
    displayName: PropTypes.string,
    isRequired: PropTypes.bool
  }))
};

export default RequiredLanguageBlock;
